<template>
  <div>
    <NavBar v-if="admin" :admin="true" :items="items" />
    <Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'mx-12' : 'pa-0'">
			<v-container>
        <v-row no-gutters class="pt-4 px-4">
          <v-col cols="10">
            <v-text-field
              solo
              v-model="search"
              :placeholder="$gettext('Search')"
              outlined
              prepend-inner-icon="search"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="2" v-if="type == 'disease' || type == 'extension'">
            <v-row v-if="admin" no-gutters justify="center" align="center" style="height: 100%">
              <v-btn color="primary" :to="{name: type == 'disease' ? 'new-icd' : 'new-extension'}">
                <v-icon class="pa-0 mr-1">add</v-icon>
                <translate>New</translate>
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" class="mt-4">
            <v-btn-toggle class="ml-2" v-model="type" mandatory>
              <v-btn value="disease" small class="text-overline" :key="1" @click="pageDisease=1; getICD()">
                <span v-translate>Disease</span>
              </v-btn>
              <v-btn value="extension" small class="text-overline" :key="2" @click="pageExtensions=1; getExtensions()">
                <span v-translate>Extension</span>
              </v-btn>
              <v-btn value="inclusion" small class="text-overline" :key="3" @click="pageInclusions=1; getInclusions()">
                <span v-translate>Inclusion</span>
              </v-btn>
              <v-btn value="exclusion" small class="text-overline" :key="4" @click="pageExclusions=1; getExclusions()">
                <span v-translate>Exclusion</span>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col v-if="type == 'disease'" cols="12" class="mt-4">
            <v-btn-toggle style="display: block" class="ml-2" v-model="chapter" mandatory @change="pageDisease=1; getICD()">
              <v-btn value="all" small class="text-overline" key="all">
                <span v-translate>All</span>
              </v-btn>
              <v-btn v-for="i in 27" :value="i" small class="text-overline" :key="i">
                <span>{{i}}</span>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" md="12" class="mt-3">
            <v-row no-gutters v-if="loading">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                top
                color="primary"
              ></v-progress-linear>
            </v-row>
            <template v-else>
              <p v-if="icdList.length == 0" class="font-weight-thin ml-2" v-translate>No results.</p>
              <template v-else>
                <ICDList
                  v-if="type == 'disease'"
                  :list="icdList"
                  :context="admin ? 'admin' :''"
                  :disabled="true"
                  :editable="true"
                  @load-more="pageDisease += 1; getICD()"
                  ref="icdList"
                  :infiniteScroll="true"
                />
                <ICDList
                  v-else-if="type == 'inclusion'"
                  :list="inclusionsList"
                  :context="admin ? 'admin' :''"
                  :disabled="true"
                  :editable="false"
                  :extension="true"
                  @load-more="pageInclusions += 1; getInclusions()"
                  ref="inclusionsList"
                  :infiniteScroll="true"
                  :other="true"
                  :exclusion="false"
                />
                <ICDList
                  v-else-if="type == 'exclusion'"
                  :list="exclusionsList"
                  :context="admin ? 'admin' :''"
                  :disabled="true"
                  :editable="false"
                  :extension="true"
                  @load-more="pageExclusions += 1; getExclusions()"
                  ref="exclusionsList"
                  :infiniteScroll="true"
                  :other="true"
                  :exclusion="true"
                />
                <ICDList
                  v-else-if="type == 'extension'"
                  :list="extensionsList"
                  :context="admin ? 'admin' :''"
                  :disabled="true"
                  :editable="false"
                  :extension="true"
                  @load-more="pageExtensions += 1; getExtensions()"
                  ref="extensionsList"
                  :infiniteScroll="true"
                />
              </template>
            </template>
          </v-col>
        </v-row>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import ICDList from "@/components/icd/ICDList.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import axios from "axios";

export default {
  name: "ICD",
  components: {
    NavBar,
    Breadcrumbs,
    ICDList
  },
  data: () => ({
    icdList: [],
    extensionsList: [],
    inclusionsList: [],
    exclusionsList: [],
    search: "",
    loading: false,
    pageDisease: 1,
    pageExtensions: 1,
    pageInclusions: 1,
    pageExclusions: 1,
    type: 'disease',
    chapter: 'all'
  }),
  computed: {
    admin() {
			return this.$store.getters.hasRole("admin");
		},
		items() {
      if (this.admin) {
        return [
          {
            text: this.$gettext("Dashboard"),
            disabled: false,
            link: true,
            to: "/admin/dashboard"
          },
          {
            text: "ICD-11",
            disabled: true,
            link: true
          }
        ];
      } else {
        return [
					{
						text: this.$gettext("Dashboard"),
						disabled: true,
						link: true,
						to: { name: "home" }
					},
					{
						text: this.$gettext("ICD-11"),
						disabled: true,
						link: true
					}
				];
      }
		}
  },
  methods: {
    makeRequest() {
			clearTimeout(this._timerId);
			if (this.search != null) {
				this._timerId = setTimeout(() => {
          if(this.type == 'disease') {
            this.pageDisease = 1;
            this.getICD();
          }
          else if(this.type == 'extension') {
            this.pageExtensions = 1;
            this.getExtensions();
          }
          else if(this.type == 'inclusion') {
            this.pageInclusions = 1;
            this.getInclusions();
          }
          else if(this.type == 'exclusion') {
            this.pageExclusions = 1;
            this.getExclusions();
          }
				}, 300);
			}
    },
    getICD() {
      if(this.pageDisease == 1) this.loading = true;
      console.log(this.chapter);
      axios
				.get("/icd/search", {
					params: { value: this.search.toLowerCase(), chapter: this.chapter, page: this.pageDisease, all_data: true }
				})
				.then(response => {
          console.log(response.data);
          if(this.pageDisease == 1) this.icdList = response.data;
          else {
            this.$refs.icdList.addICD(response.data);
          }
          this.loading = false;
        })
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    getExtensions() {
      if(this.pageExtensions == 1) this.loading = true;
      axios
				.get("/extension-codes/search", {
					params: { value: this.search.toLowerCase(), page: this.pageExtensions }
				})
				.then(response => {
          console.log(response.data);
          if(this.pageExtensions == 1) this.extensionsList = response.data;
          else {
            this.$refs.extensionsList.addICD(response.data);
          }
          this.loading = false;
        })
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    getInclusions() {
      if(this.pageInclusions == 1) this.loading = true;
      axios
				.get("/inclusions/search", {
					params: { value: this.search.toLowerCase(), page: this.pageInclusions }
				})
				.then(response => {
          console.log(response.data);
          if(this.pageInclusions == 1) this.inclusionsList = response.data;
          else {
            this.$refs.inclusionsList.addICD(response.data);
          }
          this.loading = false;
        })
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    getExclusions() {
      if(this.pageExclusions == 1) this.loading = true;
      axios
				.get("/exclusions/search", {
					params: { value: this.search.toLowerCase(), page: this.pageExclusions }
				})
				.then(response => {
          console.log(response.data);
          if(this.pageExclusions == 1) this.exclusionsList = response.data;
          else {
            this.$refs.exclusionsList.addICD(response.data);
          }
          this.loading = false;
        })
				.catch(error => {
          console.log(error);
          this.loading = false;
        });
    }
  },
  watch: {
    search() {
			this.makeRequest();
		}
  },
  created() {
    this.getICD();
	}
}
</script>